module.exports = __webpack_public_path__ + "static/nwm-a8057170cccf4e99a2c2f79c19266ef1.jpg";